.title {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.heading {
  font-size: 30px;
}

.intro {
  color: var(--ink-2);
  line-height: 1.55;
}
